import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {CommonFormService} from 'src/app/shared/utils/common-form.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../../diccionarios/moduloVMI';
import {VmiArticulosService} from '../../../services/administracion/vmi-articulos.service';
import {AG_GRID_LOCALE_ES} from '../../../diccionarios/spanishAgGrid';
import {VmiAmortiguadorService} from '../../../services/administracion/vmi-amortiguador.service';
import {ClienteModel} from '../../../models/vmi-clienteModel';
import {ArticuloModel} from '../../../models/vmi-articuloModel';
import {VmiClientesService} from '../../../services/administracion/vmi-clientes.service';
import {AmortiguadorModel} from '../../../models/vmi-amortiguadorModel';

@Component({
  selector: 'app-vmi-frm-mantenedor-amortiguador',
  templateUrl: './vmi-frm-mantenedor-amortiguador.component.html',
  styleUrls: ['./vmi-frm-mantenedor-amortiguador.component.css']
})
export class VmiFrmMantenedorAmortiguadorComponent implements OnInit {

  formulario: FormGroup;

  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  loading: boolean = false;
  listaVacia: boolean = true;

  textBoton: string;
  textoBuscar: string;
  mostrarFormulario: boolean = false;

  modulo: any = {};
  editableForm: boolean = false;

  DAT_TITULOS: any;
  titulo: any;
  AG_GRID_LOCALE_ES: any = {};
  cmbArticulos: ArticuloModel[];
  cmbClientes: ClienteModel[];

  constructor(
    private fb: FormBuilder,
    private _utils: UtilsService,
    private commonFormService: CommonFormService,
    private _amortiguador: VmiAmortiguadorService,
    private _articulo: VmiArticulosService,
    private _cliente: VmiClientesService
  ) {
  }

  ngOnInit(): void {
    this.modulo = moduloVMI;
    this.textBoton = this.modulo.button.buttonsNombre.guardar;
    this.AG_GRID_LOCALE_ES = AG_GRID_LOCALE_ES;
    this.DAT_TITULOS = this.modulo.titulos.amortiguador;
    this.titulo = this.DAT_TITULOS.tituloCardListar;

    this.formulario = this.fb.group({
      paraId: [''],
      cliente: ['', [Validators.required]],
      articulo: ['', [Validators.required]],
      artCont: [''],
      paraKiloMinimo: ['', [Validators.required]],
      paraAmortiguador: ['', [Validators.required]],
      paraFechaInicioContrato: ['', [Validators.required]],
      paraFechaFinContrato: ['', [Validators.required]],
      paraEstado: [''],
      paraConsumoTotal: ['', [Validators.required]],
      paraConsumido: ['', [Validators.required]],
      paraAlertStock: ['', [Validators.required]],
    });
    this.gridComponent();
    this.getAll();
    this.getAllClientes();
    this.getAllArticulos();
  }

  //*SERVICIOS
  getAll() {
    this._amortiguador.getAll().subscribe((res: any[]) => {
      this.loading = false;
      this.rowData = res;
      this.listaVacia = (this.rowData.length === 0) ? true : false;
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  getAllClientes() {
    this._cliente.getAll().subscribe((res: ClienteModel[]) => {
      this.cmbClientes = res;
    }, (err) => {
      this.cmbClientes = [];
    });
  }

  getAllArticulos() {
    this._articulo.getAll().subscribe((res: ArticuloModel[]) => {
      this.cmbArticulos = res;
    }, (err) => {
      this.cmbArticulos = [];
    });
  }

  gridComponent() {
    this.columnDefs = [
      {
        headerName: 'No',
        field: 'paraId',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'CLIENTE',
        field: 'cliente.cliNombre',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'ARTICULO',
        field: 'articulo.artDescripcion',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'CONTENEDOR',
        field: 'artCont',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'KILOS MINIMOS',
        field: 'paraKiloMinimo',
        sortable: true,
        filter: true,
        width: 190
      },
      {
        headerName: 'VALOR AMORTIGUADOR',
        field: 'paraAmortiguador',
        sortable: true,
        filter: true,
        width: 210
      },
      {
        headerName: 'F. INICIO CONTRATO',
        field: 'paraFechaInicioContrato',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'F. FIN CONTRATO',
        field: 'paraFechaFinContrato',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'TOT.CONSUMIDO',
        field: 'paraConsumoTotal',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'TOT.A CONSUMIR',
        field: 'paraConsumido',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'ALERTA STOCK',
        field: 'paraAlertStock',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.modulo.button.buttonsNombre.editar,
          colorBoton: this.modulo.button.buttonsCss.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.modulo.button.buttonsNombre.eliminar,
          colorBoton: this.modulo.button.buttonsCss.danger
        }
      }
    ];
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  nuevo() {
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
  }

  editar({rowData}) {
    const amortiguador: AmortiguadorModel = rowData;
    const obj = {
      paraId: amortiguador.paraId,
      cliente: amortiguador.cliente.cliId,
      articulo: amortiguador.articulo.artId,
      artCont: amortiguador.artCont,
      paraKiloMinimo: amortiguador.paraKiloMinimo,
      paraAmortiguador: amortiguador.paraAmortiguador,
      paraFechaInicioContrato: amortiguador.paraFechaInicioContrato.substring(0, 10),
      paraFechaFinContrato: amortiguador.paraFechaFinContrato.substring(0, 10),
      paraEstado: amortiguador.paraEstado,
      paraConsumoTotal: amortiguador.paraConsumoTotal,
      paraConsumido: amortiguador.paraConsumido,
      paraAlertStock: amortiguador.paraAlertStock,
    };
    this.commonFormService.abrirFormularioParaEditar(this, obj);
    this.titulo = this.DAT_TITULOS.tituloCardEditar
  }

  eliminar({rowData}) {
    const amortiguador: AmortiguadorModel = rowData;
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.eliminar,
      text: ``,
      action: this.modulo.button.buttonsNombre.eliminar,
      funcion: this._amortiguador.delete(amortiguador.paraId),
    }).then((res: any) => {
      this.getAll();
    }).catch((err) => {
      console.log(err);
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizar();
      } else {
        this.guardar();
      }
    } else {
      this.regresar();
    }
  }

  guardar() {
    const idCliente: number = Number(this.formulario.get('cliente').value);
    const idArticulo: number = this.formulario.get('articulo').value;
    let amortiguador: AmortiguadorModel = Object.assign({}, this.formulario.value);
    amortiguador.articulo = this.cmbArticulos.find(articulo => articulo.artId === idArticulo);
    amortiguador.cliente = this.cmbClientes.find(cliente => cliente.cliId === idCliente);
    amortiguador.paraEstado = 1;
    amortiguador.paraFechaInicioContrato = amortiguador.paraFechaInicioContrato + 'T00:00:00';
    amortiguador.paraFechaFinContrato = amortiguador.paraFechaFinContrato + 'T00:00:00';
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.guardar,
      text: ``,
      action: this.modulo.button.buttonsNombre.guardar,
      funcion: this._amortiguador.create(amortiguador),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  actualizar() {
    const idCliente: number = Number(this.formulario.get('cliente').value);
    const idArticulo: number = this.formulario.get('articulo').value;
    let amortiguador: AmortiguadorModel = Object.assign({}, this.formulario.value);
    amortiguador.articulo = this.cmbArticulos.find(articulo => articulo.artId === idArticulo);
    amortiguador.cliente = this.cmbClientes.find(cliente => cliente.cliId === idCliente);
    amortiguador.paraFechaInicioContrato = amortiguador.paraFechaInicioContrato + 'T00:00:00';
    amortiguador.paraFechaFinContrato = amortiguador.paraFechaFinContrato + 'T00:00:00';
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.actualizar,
      text: ``,
      action: this.modulo.button.buttonsNombre.actualizar,
      funcion: this._amortiguador.edit(amortiguador),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  regresar() {
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.commonFormService.limpiarYregrear(this);
  }

}
